import axios from 'axios';
import BaseApi from './base-api';

/**
 * API for the AI assistant (ChatGPT via backend).
 * GET /assistant/chat - load current conversation
 * POST /assistant/chat - send message
 * DELETE /assistant/chat - clear conversation
 */
class AssistantApi extends BaseApi {
  getMessages() {
    return axios
      .get(`${this.baseUrl}/assistant/chat`, { loadingDisabled: true })
      .then((response) => ({
        ok: true,
        messages: response.data.messages || [],
        conversationId: response.data.conversation_id,
        pendingNavigation: response.data.pending_navigation || null,
      }))
      .catch((error) => {
        const errors = (error.response &&
          error.response.data &&
          error.response.data.errors) || ['Failed to load chat'];
        return { ok: false, errors };
      });
  }

  sendMessage(messages, conversationId = null, context = null) {
    const payload = { messages };
    if (conversationId) {
      payload.conversation_id = conversationId;
    }
    if (context) {
      payload.context = context;
    }

    return axios
      .post(`${this.baseUrl}/assistant/chat`, payload)
      .then((response) => ({
        ok: true,
        message: response.data.message,
        conversationId: response.data.conversation_id,
        navigation: response.data.navigation || null,
      }))
      .catch((error) => {
        const errors = (error.response &&
          error.response.data &&
          error.response.data.errors) || ['Failed to send message'];
        return { ok: false, errors };
      });
  }

  clearChat() {
    return axios
      .delete(`${this.baseUrl}/assistant/chat`, { loadingDisabled: true })
      .then(() => ({ ok: true }))
      .catch((error) => {
        const errors = (error.response &&
          error.response.data &&
          error.response.data.errors) || ['Failed to clear chat'];
        return { ok: false, errors };
      });
  }
}

export const assistantApi = new AssistantApi();
